import { Component } from '@angular/core';
import { PairCodeInputComponent } from '@era/devices';

@Component({
  selector: 'era-pair-page',
  templateUrl: './pair.page.html',
  styleUrls: ['./pair.page.scss'],
  imports: [PairCodeInputComponent],
})
export class PairPage {}
